import { cx } from '@emotion/css';
import Multiselect from 'multiselect-react-dropdown';
import { type FC, useMemo } from 'react';

import { MotifComponent } from '../../motif/motifConstants';
import { useMotifStyles } from '../../motif/motifReactUtils';
import { Icon } from '../Icon';
import type { MultiSelectProps } from './MultiSelect.types';
import {
  multiSelectArrowCss,
  multiSelectCloseIconCss,
  multiSelectDropdownBaseCss,
  multiSelectWrapperCss,
} from './styles';

/**
 * Generic multi-select dropdown wrapping multiselect-react-dropdown.
 *
 * Provides structural layout (wrapper, arrow icon, black cross chip remove icon).
 */
export const MultiSelect: FC<MultiSelectProps> = ({
  options,
  selectedValues,
  displayValue = 'name',
  placeholder,
  showCheckbox,
  hidePlaceholder = true,
  avoidHighlightFirstOption = true,
  onSelect,
  onRemove,
  onKeyPressFn,
  dropdownClassName,
  wrapperClassName,
  arrowClassName,
}) => {
  useMotifStyles(MotifComponent.MULTI_SELECT);

  const closeIcon = useMemo(() => <Icon name="cross" className={multiSelectCloseIconCss} />, []);

  return (
    <div className={cx(MotifComponent.MULTI_SELECT, multiSelectWrapperCss, wrapperClassName)}>
      <Multiselect
        options={options}
        selectedValues={selectedValues}
        displayValue={displayValue}
        placeholder={placeholder}
        showCheckbox={showCheckbox}
        hidePlaceholder={hidePlaceholder}
        avoidHighlightFirstOption={avoidHighlightFirstOption}
        onSelect={onSelect}
        onRemove={onRemove}
        onKeyPressFn={onKeyPressFn}
        className={cx(multiSelectDropdownBaseCss, dropdownClassName)}
        customCloseIcon={closeIcon}
      />
      <Icon name="chevron-down" className={cx(multiSelectArrowCss, arrowClassName)} />
    </div>
  );
};

MultiSelect.displayName = 'MultiSelect';
